import React from 'react'
import { Link } from 'react-router-dom'
import Icon from '../misc/Icons'
import { getRepoforId } from '../../utils/getRepoforId'
import { getLinkForRepo } from '../../utils/getLinkForRepo'

function LocalBadge({ folder }) {
  if (!folder.__localOrigin) return null
  if (folder.__localEngine === 'minisearch') {
    return <Icon name='local-source-bm25' className='searchResults-localBadge searchResults-localBadge--bm25' />
  }
  return <Icon name='local-source' className='searchResults-localBadge' />
}

class SearchResultsFolderCard extends React.Component {
  render() {
    const { folder } = this.props
    let linkPath = `/library/${folder.id}`
    let repoName = null
    let inSharedRepo = false
    let inPublicConsumerRepo = false
    let parentRepo
    if (folder.repo) {
      parentRepo = getRepoforId(folder.repo)
      if (parentRepo) {
        repoName = parentRepo.name
        inSharedRepo = parentRepo.shared
        inPublicConsumerRepo = parentRepo.role === 'consumer'
        linkPath = `${getLinkForRepo(parentRepo)}/${folder.id}`
      } else {
        linkPath = `/packs/${folder.repo}/${folder.id}`
      }
    }

    return (
      <Link to={linkPath}>
        <div className='searchResultsRow searchResultsRow--folder'>
          <div className='searchResultsRow-icon'>
            <Icon name={!folder.readOnly ? 'folder' : 'folder-isbe'} />
          </div>
          <div className='searchResultsRow-body'>
            <div className='searchResultsRow-title'>
              <span className='searchResultsRow-title-text'>{folder.name}</span>
              {inSharedRepo && <Icon name='shared' />}
              {inPublicConsumerRepo && <Icon name='globe-shared' />}
              <LocalBadge folder={folder} />
            </div>
            {repoName && (
              <div className='searchResultsRow-meta'>
                <Link to={getLinkForRepo(parentRepo)} className='searchResultsRow-repoLink'>
                  {repoName}
                </Link>
              </div>
            )}
          </div>
        </div>
      </Link>
    )
  }
}

export default SearchResultsFolderCard
